import React from 'react'

// Persistent warning shown whenever the cart holds labs from 2+ companies.
// Visibility is driven entirely by the server-computed `cart.mixed_lab_company`
// flag (already false when the labcorp integration is disabled), so both the
// cart drawer and the checkout cart pane render the identical copy off one source.
export default function MixedLabCompanyBanner({ show }) {
  if (!show) {
    return null
  }

  return (
    <div className="alert alert-warning mx-3 mb-3" role="status" aria-live="polite">
      This order includes tests from multiple lab companies.
    </div>
  )
}
